import { render, staticRenderFns } from "./InPlace.vue?vue&type=template&id=dcdb2526&"
import script from "./InPlace.vue?vue&type=script&lang=ts&"
export * from "./InPlace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports